import axios from "axios";
const user = {
  state: {
    chatList: [],
    isWakeUp: false,
    isSpeaking: false,
    knowledgeUrl:
      window._CONFIG.FINE_URL +
      "/webroot/decision/view/duchamp?viewlet=msp%252Fzsck%252Fzscq.fvs&page_number=1&fine_auth_token=",
    knowledgeLiteUrl:
      window._CONFIG.FINE_URL +
      "/webroot/decision/view/duchamp?viewlet=msp%252Fzsck-home%252Fzscq.fvs&page_number=1&fine_auth_token=",
    jumpUrl:
      window._CONFIG.FINE_URL +
      "/webroot/decision/view/duchamp?viewlet=msp%252Fzsck%252Fportal.fvs&page_number=1&fine_auth_token=",
    token: window._CONFIG.FINE_AUTH_TOKEN,
  },
  mutations: {
    /**
     * 聊天记录
     */
    setChatList(state, obj) {
      // 如果存在等待回答的数据
      // 如果存在 就替换
      let index = state.chatList.findIndex((item) => item.loading);
      if (index > -1) {
        state.chatList.splice(index, 1, obj);
      } else {
        state.chatList.push(obj);
      }
    },
    setWakeUpChatList(state) {
      let wakeUpObj = {
        msgType: "AI",
        type: "wakeup",
        msg: "我在，您请说：",
        url: "",
      };
      state.chatList = [wakeUpObj];
    },
    setIsWakeUp(state, p) {
      state.isWakeUp = p;
    },
    setJumpUrl(state, p) {
      state.jumpUrl = p;
    },
    setKnowledgeJumpUrl(state, p) {
      state.knowledgeUrl = p;
    },
    setKnowledgeLiteJumpUrl(state, p) {
      state.knowledgeLiteUrl = p;
    },
    setIsSpeaking(state, p) {
      state.isSpeaking = p;
    },
  },
  actions: {
    getRebotAnswer({ commit, state }, params) {},
  },
};

export default user;
